export enum MembershipTypesEnum {
  SIGNATURE = 'SIGNATURE',
  ELAC = 'ELAC',
  NONE = 'NONE',
  XO_MEMBER = 'XO_MEMBER',
  XO_NON_MEMBER = 'XO_NON_MEMBER',
  JE_RESERVE = 'JE_RESERVE'
}
